import StandardError from '@/modules/errors/Standard'

class SignInError extends StandardError {
  constructor(message: string, status = 400, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}
export default SignInError
